export const urlPrefix = 'pms-web';

// 爬虫
export const spiderUrlPrefix = 'spider';
export const url = 'url';

export const sysNoticeUrlPrefix = 'hotel-misc-svc';
